export default __webpack_public_path__ + "static/media/Frosch-mit-Pilzen.1c34abe6.png";